import { ReactElement, useMemo, memo } from 'react';
import { get } from 'lodash';

import { ActivatedChipRoot } from '~components/ActivatedChip/styles';

import {
  IsAvailableChipProps,
  IsAvailableChipTypeMapping,
  IsAvailableChipType,
} from './types';

const typeMapping: IsAvailableChipTypeMapping = {
  available: {
    label: 'Libre',
    color: 'success',
  },
  inTravel: {
    label: 'Ocupado',
    color: 'warning',
  },
  outOfWork: {
    label: 'Fuera de jornada',
    color: 'warning',
  },
  assigned: {
    label: 'Asignado a ruta',
    color: 'primary',
  },
};

const IsAvailableChip = ({
  isAvailable,
  isOpenForWork = true,
  isAssigned = false,
  size = 'medium',
  variant = 'outlined',
}: IsAvailableChipProps): ReactElement => {
  const type = useMemo<IsAvailableChipType>(() => {
    if (isAssigned) return 'assigned';

    if (!isOpenForWork) return 'outOfWork';

    if (isAvailable) return 'available';

    return 'inTravel';
  }, [isAssigned, isOpenForWork, isAvailable]);

  const currentTypeData = useMemo(() => get(typeMapping, type), [type]);

  return (
    <ActivatedChipRoot
      variant={variant}
      label={currentTypeData.label}
      color={currentTypeData.color}
      size={size}
    />
  );
};

export default memo(IsAvailableChip);
